import * as React from 'react';
import { observer } from 'mobx-react';
import { Spinner } from '@teliaee/design-system';
import { isValidHttpUrl } from '../util/ValidationUtil';

interface LaresPostFormProps {
  formPostUrl: string;
  lares: string;
}

const LaresPostForm = observer((props: LaresPostFormProps): React.JSX.Element => {
  const { formPostUrl, lares } = props;
  const form = React.createRef<HTMLFormElement>();

  React.useEffect(() => {
    form.current?.submit();
  }, []);

  if (!isValidHttpUrl(formPostUrl)) {
    throw new Error(`Invalid URL for goto parameter: ${formPostUrl}`);
  }

  return (
    <>
      <Spinner />
      <form name="cdcLoginForm" method="post" action={formPostUrl} acceptCharset="UTF-8" ref={form}>
        <input type="hidden" name="LARES" value={lares} />
      </form>
    </>
  );
});

export default LaresPostForm;
